import onlyLetters from "@/directives/OnlyLetters";

export default {
  install (Vue) {
    Vue.directive('onlyLetters', onlyLetters)
  }
}